import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dw-sidebar-couriers" }
const _hoisted_2 = {
  key: 0,
  class: "dw-sidebar-couriers__statement"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dw_sidebar_courier = _resolveComponent("dw-sidebar-courier")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.couriers.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Список пуст "))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.couriers, (courier) => {
      return (_openBlock(), _createBlock(_component_dw_sidebar_courier, {
        key: courier.courierId,
        courier: courier,
        "route-showed": _ctx.showedRoutesCouriersIds.includes(courier.courierId),
        "is-completed-orders-enabled": _ctx.isCompletedOrdersEnabled,
        "is-problems-enabled": _ctx.isProblemsEnabled,
        "is-deliveries-enabled": _ctx.isDeliveriesEnabled,
        "is-undelivered-deliveries-enabled": _ctx.isUndeliveredDeliveriesEnabled,
        "is-takes-enabled": _ctx.isTakesEnabled,
        "is-unassigned-takes-enabled": _ctx.isUnassignedTakesEnabled,
        "selected-sidebar-feature-id": _ctx.selectedSidebarFeatureId,
        onShowRoute: _ctx.onShowRoute,
        onEntityClicked: _ctx.onEntityClicked
      }, null, 8, ["courier", "route-showed", "is-completed-orders-enabled", "is-problems-enabled", "is-deliveries-enabled", "is-undelivered-deliveries-enabled", "is-takes-enabled", "is-unassigned-takes-enabled", "selected-sidebar-feature-id", "onShowRoute", "onEntityClicked"]))
    }), 128))
  ]))
}